import { Field, LinkField, RichTextField } from '@sitecore-jss/sitecore-jss-nextjs';
import {
  AnchorTargetParams,
  DynamicPlaceholderParams,
  RenderingProps,
  TranslationOptionsParams,
} from 'src/shared/shared.types';

export type C40SimpleSignUpFields = {
  Headline?: Field<string>;
  SupportCopy?: RichTextField;
  CTA?: LinkField;
  FormID?: Field<string>;
};

export type C40SimpleSignUpParams = {
  HeadlineTag?: string;
  BackgroundColor?: string;
  Alignment?: string;
} & DynamicPlaceholderParams &
  TranslationOptionsParams &
  AnchorTargetParams;

export type C40SimpleSignUpProps = RenderingProps<C40SimpleSignUpFields, C40SimpleSignUpParams> & {
  formioProjectUrl?: string;
  formioScript?: string;
};
